import { useQuery } from '@apollo/client'
import type { GetAppointmentQuery, GetAppointmentQueryVariables } from '@models/generated/graphql'
import { GET_APPOINTMENT } from './queries.gql'

/**
 * Custom hook pour récupérer un rendez-vous
 */
export function useGetAppointment(id: string) {
  const { data, loading, error } = useQuery<GetAppointmentQuery, GetAppointmentQueryVariables>(GET_APPOINTMENT, {
    variables: { id },
    skip: !id
  })

  return {
    appointment: data?.appointment,
    loading,
    error
  }
}
